// dependencies
import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { format } from "date-fns";

// components
import Button from "Components/Button";
import DatePicker from "react-datepicker";
import TextInput from "Components/Inputs/Text";

// actions
import { changePageUI as updateUI } from "Actions/ui";
import { sendCompanySettingUpdate } from "./actions";

// selectors
import { getIsRequesting } from "Selectors/app";

// css
import css from "./CompanySettings";

import "react-datepicker/dist/react-datepicker.css";

class CompanySetting extends React.PureComponent {
	static propTypes = {
		isUpdatingCompanySettings: PropTypes.bool.isRequired,
		sendCompanySettingUpdate: PropTypes.func.isRequired,
		name: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		type: PropTypes.oneOf(["text", "date", "number", "boolean"]).isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.bool])
			.isRequired,
	};

	constructor(props) {
		super(props);

		const dateValue = moment(props.value);

		this.state = {
			value: props.value,
			stringValue: props.value.toString(),
			// Converting to toDate moves to localTime but needs to stay UTC
			dateValue: dateValue.isValid() ? dateValue.add(1, "d").toDate() : null,
		};
	}

	handleDateChange = (newValue) => {
		// Need to parse and store date as UTC to match performyard,
		// but do not change for state or react date picker Breaks
		let utcDate = format(newValue, "yyyy-MM-dd");
		utcDate += "T00:00:00.000Z";
		this.setState({ value: utcDate, dateValue: newValue });
	};

	handleTextChange = (newValue) => {
		const update = { stringValue: newValue, value: newValue };
		if (this.props.type === "number") {
			update.value = Number(newValue);
		}
		this.setState(update);
	};

	handleBooleanChange = (event) => {
		const newValue = event.target.checked;
		const update = { value: newValue };
		this.setState(update);
	};

	handleSubmit = () => {
		this.props.sendCompanySettingUpdate(this.props.name, this.state.value);
	};

	render = () => {
		const { isUpdatingCompanySettings, label } = this.props;

		return (
			<div className={css.CompanySetting}>
				<div className={css.label}>{label}</div>

				<div className={css.inputsContainer}>
					<div className={css.input}>
						{this.props.type === "date" ? (
							<DatePicker selected={this.state.dateValue} onChange={this.handleDateChange} />
						) : null}

						{this.props.type === "number" ? (
							<TextInput value={this.state.stringValue} onChange={this.handleTextChange} />
						) : null}

						{this.props.type === "text" ? (
							<TextInput value={this.state.stringValue} onChange={this.handleTextChange} />
						) : null}

						{this.props.type === "boolean" ? (
							<input
								type="checkbox"
								checked={this.state.value ? "checked" : ""}
								onChange={this.handleBooleanChange}
							/>
						) : null}
					</div>

					<Button isRequesting={isUpdatingCompanySettings} onClick={this.handleSubmit} className={css.button}>
						Save
					</Button>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	isUpdatingCompanySettings: getIsRequesting(state, "COMPANIES:SETTINGS.UPDATE"),
});

const mapDispatchToProps = (dispatch) => ({
	sendCompanySettingUpdate: (key, value) => {
		dispatch(sendCompanySettingUpdate(key, value));
		dispatch(updateUI(["company", key], value));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanySetting);
